import styled, { createGlobalStyle } from 'styled-components';

export const NewVersionToastStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .new-version-title {
    margin: 0;
    font-weight: 600;
    color: #343a40;
  }

  .new-version-text {
    margin: 0;
    font-size: 0.8125rem;
  }

  .btn {
    align-self: flex-start;
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
`;

// Same colored bar the other toasts show as their progress bar
export const NewVersionToastGlobalStyles = createGlobalStyle`
  .Toastify__toast.new-version-toast {
    border-bottom: 5px solid var(--toastify-color-progress-info);
  }
`;
